import {AnError} from "../model/misc";
import {getCookie} from "./crypto";

export const endpoint = process.env.NODE_ENV === "development" ? "http://127.0.0.1" : "https://api.hoarfroster.space"
export const staticResourcesEndpoint = process.env.NODE_ENV === "development" ? "http://127.0.0.1:34567" : "https://cdn.hoarfroster.space"

export const getRaw = async (path: string): Promise<{ data: any | AnError, code: number }> => {
    return (await internalFetch(path, 'GET'));
}

export const getItem = async <T>(path: string): Promise<{ data: T | AnError, code: number }> => {
    return await internalFetch(path, 'GET');
}

export const getItems = async <T>(path: string): Promise<{ data: T[] | AnError, code: number }> => {
    return await internalFetch(path, 'GET');
}

export const postRaw = async (path: string, data: any = undefined, headers: any = {}): Promise<{
    data: any,
    code: number
}> => {
    return await internalFetch(path, 'POST', data, headers);
}

const internalFetch = async (path: string, method: string, data: any = undefined, headers: any = {}): Promise<{
    data: any,
    code: number
}> => {
    try {
        let url = new URL(`${endpoint}${path}`);
        url.searchParams.set("token", getCookie("token") ?? "");

        let response = await fetch(url.href, {
            method: method,
            headers: method === "GET" ? undefined : {
                'Content-Type': 'application/json',
                ...headers
            },
            body: method === "GET" ? undefined : JSON.stringify(data)
        }), json = await response.json();

        if (response.ok) {
            return {data: json, code: 200};
        } else {
            return {data: json, code: response.status};
        }
    } catch (error: any) {
        return {data: {error: error.toString()}, code: 500};
    }
}

export const saveItem = async <T>(path: String, data: T): Promise<{ data: boolean, code: number }> => {
    try {
        let response = await fetch(`${endpoint}${path}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });

        if (response.ok) {
            return {data: true, code: 200};
        } else {
            return {data: false, code: response.status};
        }
    } catch (error: any) {
        return {data: false, code: 500};
    }
}